import script from "./ProjectCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCalendar.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCalendar.vue?vue&type=style&index=0&id=47fb19d1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47fb19d1"]])

export default __exports__